import Form from "shared/components/inputs/form/Form";
import ModalActions from "shared/components/feedback/modals/ModalActions";
import PropTypes from "prop-types";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import { sendNotification } from "shared/components/feedback/notification/notification";
import { useParams } from "react-router";
import { useProjectsApi } from "features/admin/projects/useProjects";
import useProjectsLinked from "features/admin/projects/single/useProjectsLinked";
import { useState } from "react";

const ProjectLinkDeleteModal = ({ projectLinkIdToDelete, onClose }) => {
    const { projectId } = useParams();
    const { useProjectById } = useProjectsApi();
    const projectData = useProjectById(projectId);
    const { useProjectsRelatedList, deleteRelatedProject } =
        useProjectsLinked();
    const relatedProjectsList = useProjectsRelatedList({ jobID: projectId });
    const [inProgress, setInProgress] = useState(false);

    if (relatedProjectsList?.isLoading || projectData.isLoading) {
        return <>Loading...</>;
    }

    if (relatedProjectsList?.isError || projectData.isError) {
        return <>Error</>;
    }

    const currentProjectLinkData = relatedProjectsList.data.find(
        (projectLink) => projectLink.relatedJobID === projectLinkIdToDelete
    );

    if (!currentProjectLinkData) {
        return <div>Could not find project link</div>;
    }

    const modifier = deleteRelatedProject;

    const onSubmit = async () => {
        const data = {
            id: projectId,
            relatedJobId: projectLinkIdToDelete,
        };
        await modifier.mutateAsync(data);
        setInProgress(false);
        sendNotification(
            <>
                <strong>{currentProjectLinkData.Name}</strong> link has been
                removed
            </>
        );
        onClose();
    };

    return (
        <Form onSubmit={onSubmit}>
            <VStack spacing="Three">
                <VStack>
                    <Text variant="Body_1_1" color="Gray_2">
                        Are you sure you&apos;d like to remove{" "}
                        <span style={{ fontWeight: "700" }}>
                            {currentProjectLinkData.Name}
                        </span>{" "}
                        Link?
                    </Text>
                </VStack>
                <ModalActions
                    primaryAction={{
                        type: "submit",
                        label: "Yes, Remove",
                    }}
                    secondaryAction={{
                        type: "button",
                        label: "Cancel",
                        onClick: onClose,
                    }}
                    as="fieldset"
                    disabled={modifier.isLoading || inProgress}
                />
            </VStack>
        </Form>
    );
};

ProjectLinkDeleteModal.propTypes = {
    projectLinkIdToDelete: PropTypes.number.isRequired,
    onClose: PropTypes.func.isRequired
};

export default ProjectLinkDeleteModal;
